<app-loader *ngIf="isLoading"></app-loader>
<ng-template #template>
  <div class="row" *ngIf="isTeamManager">
    <div class="col-md-12">
      <h5 class="modal-title modal-container quick-create-modal-rtl">
        {{ 'COMMON.TEAM_USERS_FILTER' | translate }}
      </h5>
    </div>
  </div>

  <div
    class="container modal-container team-user-container"
    *ngIf="isTeamManager"
  >
    <div class="row quick-create-modal-rtl">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
          <div class="node-container">
            <!-- use a disabled button to provide padding for tree leaf -->
            <button mat-icon-button disabled></button>
            <span class="node-text">{{ node.name }}</span>
            <span class="node-actions">
              <a
                class="col-grey icon-container team-user-filter-rtl"
                (click)="openTeamUserModal(node)"
                matTooltip="{{ 'COMMON.ADD_TEAM_USERS' | translate }}"
                ><span
                  class="material-icons-outlined"
                  [ngClass]="{ 'green-icon': isGreen(node.id) }"
                  >group_add</span
                ></a
              >
            </span>
          </div>
        </mat-tree-node>

        <!-- This is the tree node template for expandable nodes -->
        <mat-tree-node
          *matTreeNodeDef="let node; when: hasChild"
          matTreeNodePadding
        >
          <div class="node-container">
            <button
              mat-icon-button
              matTreeNodeToggle
              [attr.aria-label]="'Toggle ' + node.name"
            >
              <mat-icon class="mat-icon-rtl-mirror">
                {{
                  treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'
                }}
              </mat-icon>
            </button>
            <span class="node-text">{{ node.name }}</span>
            <span class="node-actions">
              <a
                class="col-grey icon-container team-user-filter-rtl"
                (click)="openTeamUserModal(node)"
                matTooltip="{{ 'COMMON.ADD_TEAM_USERS' | translate }}"
                ><span
                  class="material-icons-outlined"
                  [ngClass]="{ 'green-icon': isGreen(node.id) }"
                  >group_add</span
                ></a
              >
            </span>
          </div>
        </mat-tree-node>
      </mat-tree>
    </div>
  </div>

  <div
    class="row privileged-user-header quick-create-modal-rtl"
    *ngIf="isPrivilegedUser"
  >
    <div class="col-md-6">
      <h5 class="modal-title modal-container">
        {{ 'COMMON.PRIVILEGED_USERS_FILTER' | translate }}
      </h5>
    </div>
    <div class="col-md-6 mt-4 d-flex flex-row-reverse">
      <a
        class="col-grey privileged-user-container privileged-user-filter-rtl"
        (click)="openPrivilegedUserModal()"
        matTooltip="{{ 'COMMON.ADD_PRIVILEGED_USERS' | translate }}"
        ><span
          class="material-icons-outlined"
          [ngClass]="{ 'green-icon': isPrivilegedUserSelected() }"
          >group_add</span
        ></a
      >
    </div>
  </div>
  <div class="row quick-create-modal-rtl mt-4">
    <div class="col-md-12 d-flex flex-row-reverse">
      <button
        mat-stroked-button
        color="primary"
        class="btn-border outline-info-btn btn-text-size"
        (click)="handleCancel()"
      >
        {{ 'COMMON.CLOSE' | translate }}<mat-icon>cancel</mat-icon>
      </button>
      &nbsp; &nbsp;
      <button
        mat-stroked-button
        color="primary"
        class="btn-border outline-info-btn btn-text-size"
        (click)="clearAllUser()"
      >
        {{ 'COMMON.CLEAR_ALL_USERS' | translate }}<mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>
</ng-template>

<app-team-users-add [selectedTeamName]="selectedTeamName"></app-team-users-add>
<app-privileged-user-add></app-privileged-user-add>
